<!--Copyright (c) PikPok. All rights reserved-->
<template>
  <v-container :fluid="true" class="ma-0 pa-0" v-if="loading">
    <v-row class="text-white bg-yellow-darken-3 pa-3 mt-0">
      <router-link to="/">
        <v-icon color="white" icon="mdi-less-than" size="x-large" class="pr-5 pl-5"></v-icon>
      </router-link>
      <v-icon color="white" icon="mdi-controller" size="x-large" class="pr-5 pl-5"></v-icon>
      <h3 class="pt-1">
        {{ bugReport.strings.BUG_GAME_SUGGESTIONS }}
      </h3>
    </v-row>
    <v-row v-if="!formSubmit">
      <v-col offset-lg="2" lg="8" offset="1" cols="10">
        <v-select
            v-model="formDetails.game_suggestions_and_community_feedback"
            :items="bugReport.game_suggestions_and_community_feedback"
            :rules="[v => !!v]"
            :label=bugReport.strings.BUG_GAME_SUGGESTIONS
            :placeholder=bugReport.strings.BUG_CHOOSE_OPTION
            required variant="solo-filled" return-object
        ></v-select>
        <v-form ref="form" lazy-validation v-if="!!formDetails.game_suggestions_and_community_feedback">
          <v-text-field
              v-model="formDetails.in_game_username"
              :label=bugReport.strings.BUG_IN_GAME_USERNAME
              :placeholder=bugReport.strings.BUG_IN_GAME_USERNAME_HINT
              required
              variant="solo-filled"
              v-if="formDetails.game_suggestions_and_community_feedback.value !== 'Report an Ad'"
              @blur="validateUsername"
          ></v-text-field>
          <v-text-field
              v-model="formDetails.email"
              :rules="[v => !!v, v => !v || /\s*\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})\s*/.test(v)]"
              :label=bugReport.strings.BUG_EMAIL
              :placeholder=bugReport.strings.BUG_EMAIL_HINT
              required variant="solo-filled"
          ></v-text-field>
          <v-select
              v-model="formDetails.game"
              :items="appList"
              :rules="[v => !!v]"
              :label=bugReport.strings.BUG_GAME
              :placeholder=bugReport.strings.BUG_CHOOSE_OPTION
              required variant="solo-filled"
          ></v-select>
          <v-textarea
              v-if="!['Comments on community management or developer communication', 'Report an Ad'].includes(formDetails.game_suggestions_and_community_feedback.value)"
              v-model="formDetails.feature_suggestion"
              :rules="[v => !!v]"
              :label=bugReport.strings.BUG_FEATURE_SUGGESTION
              :placeholder=bugReport.strings.BUG_FEATURE_SUGGESTION_INFO
              required variant="solo-filled"
          ></v-textarea>
          <v-textarea
              v-if="!['Comments on community management or developer communication', 'Report an Ad'].includes(formDetails.game_suggestions_and_community_feedback.value)"
              v-model="formDetails.feature_justification"
              :rules="[v => !!v]"
              :label=bugReport.strings.BUG_JUSTIFICATION
              :placeholder=bugReport.strings.BUG_JUSTIFICATION_INFO
              required variant="solo-filled"
          ></v-textarea>
          <v-text-field
              v-model="formDetails.ad_provider"
              v-if="formDetails.game_suggestions_and_community_feedback.value === 'Report an Ad'"
              :rules="[v => !!v]"
              :label=bugReport.strings.BUG_AD_PROVIDER
              required variant="solo-filled"
          ></v-text-field>
          <v-textarea
              v-if="['Comments on community management or developer communication', 'Report an Ad'].includes(formDetails.game_suggestions_and_community_feedback.value)"
              v-model="formDetails.description"
              :rules="[v => !!v]"
              :label=bugReport.strings.BUG_DESCRIPTION
              required variant="solo-filled"
          ></v-textarea>
          <v-file-input
              v-model="files"
              :label=bugReport.strings.BUG_ATTACHMENTS
              multiple
              :rules=attachmentRules
              @change="onFilePicked"
              class="file-input-style"
              :key="fileUploadKey"
          >
            <template v-slot:selection="{ fileNames }">
              <v-chip
                  color="green"
                  variant="flat"
                  class="me-2"
                  size="small"
                  v-for="(fileName, index) in fileNames" :key="index"
                  label
                  closable
                  @click:close="deleteChip(fileName)">
                {{ fileName }}
              </v-chip>
            </template>
          </v-file-input>
          <!-- Google Captcha -->
          <GoogleRecaptcha ref="recaptcha" @verify="onSubmit"></GoogleRecaptcha>
          <!-- Submit -->
          <v-btn
              color="yellow-darken-3"
              class="mt-4 mb-5 text-white"
              block
              @click="executeRecaptcha"
          >
            {{ bugReport.strings.BUG_SUBMIT }}
          </v-btn>
        </v-form>
      </v-col>
    </v-row>
    <!-- Success or Error response after submit -->
    <v-row v-else class="mt-10">
      <v-col offset-lg="2" lg="8" offset="1" cols="10">
        <p v-if="error">{{ bugReport.strings.PRIVACY_ERROR }}</p>
        <p v-else v-html="bugReport.strings.BUG_FEEDBACK_THANKS"></p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import GoogleRecaptcha from "@/components/Recaptcha";

export default {
  name: "GameSuggestionsAndFeedback",
  components: {GoogleRecaptcha},
  data() {
    return {
      formDetails: {},
      loading: false,
      formSubmit: false,
      error: false,
      copyFormDetails: {},
      attachmentRules: [
        v => !v.some(file => file.size > 5242880) || 'File size should be less than 5MB',
        v => v.length <= 5 || 'Maximum number of files limit is 5'
      ],
      files: [],
      fileUploadKey: 0,
      appList: [],
    }
  },
  computed: {
    ...
        mapState({
          bugReport: state => state.supportStore.bugReport,
        }),
  },
  mounted() {
    this.getBugReport({
      params: {
        ...this.$route.query
      }
    }).then((response) => {
      this.loading = true
      this.formDetails = JSON.parse(JSON.stringify(response.data.form_details))
      this.formDetails.attachments = []
      response.data.appList.forEach(app => {
        this.appList.push({
          value: app[0],
          title: app[1],
        })
        // Contact us form - Set game name
        app[0].toLowerCase() == this.formDetails.game.toLowerCase()
            ? this.formDetails.game = app[0]
            : this.formDetails.game === '' && app[0].toLowerCase() == this.formDetails.appname.toLowerCase()
                ? this.formDetails.game = app[0] : null
      })
    })
  },
  methods: {
    async onSubmit(result) {
      const {valid} = await this.$refs.form.validate()
      if (valid) {
        this.postBugReport({
          data: {
            ...this.formDetails,
            grecaptchaResponse: result,
            formType: 'game_suggestions_and_community_feedback'
          },
        }).then((response) => {
          this.formSubmit = true
          this.error = response.data.error
        })
      } else {
        // Scroll to first error field
        this.$nextTick(() => {
          let topOfElement = document.querySelector('.v-field--error.v-field--error:first-of-type').offsetTop - 100
          window.scroll({top: topOfElement, behavior: "smooth"})
        })
      }
    },

    executeRecaptcha() {
      this.$refs.recaptcha.execute()
    },

    onFilePicked(event) {
      this.formDetails.attachments = []
      for (let i = 0; i < event.target.files.length; i++) {
        let reader = new FileReader()
        reader.readAsDataURL(event.target.files[i])
        reader.onload = () => {
          this.formDetails.attachments.push({
            data: reader.result.split(',')[1],
            name: event.target.files[i].name,
            content_type: event.target.files[i].type
          })
        }
      }
    },

    deleteChip(fileName) {
      this.formDetails.attachments = this.formDetails.attachments.filter(file => file.name !== fileName)
      this.files = this.files.filter(file => file.name !== fileName)
      this.fileUploadKey += 1
    },

    validateUsername() {
      let blocked = ['n/a', 'na']
      let val = (this.formDetails.in_game_username || '').trim().toLowerCase()
      if (blocked.includes(val)) {
          this.formDetails.in_game_username = ''
      }
    },

    ...mapActions([
      'getBugReport',
      'postBugReport'
    ])
  }
}
</script>

<style scoped lang="scss">
@media only screen and (max-width: 550px) {
  .small-button-height {
    height: 70px;
  }
}

:deep .file-input-style .v-field__input {
  position: relative !important;
  top: 0 !important;
  left: 0 !important;
  z-index: 2 !important;
}
</style>
